import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-card-four-guaranteed-service',
  templateUrl: './card-four-guaranteed-service.component.html',
  styleUrls: ['./card-four-guaranteed-service.component.scss']
})
export class CardFourGuaranteedServiceComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
